import { getQueryStringValue } from 'utilities/browser';
import { delayedCall } from 'utilities/function';

qtee.customDesign = window.qtee.customDesign || {};

qtee.shared = qtee.shared || {};
qtee.shared.ProdModel = Backbone.Model.extend({
	urlRoot: '/api/customizedproducts/productdetail/',

	url () {

		const shortSku = this.get('ShortSku');
		let url;

		url = `${this.urlRoot + shortSku}/`;

		return url;

	}
});

/**
 * Backbone customDesign API sync Adapter
 *
 * since Backend returns 200 status code even on errors we need this Adapter to check OperationResult
 * this sync method:
 * 	1. call error if OperationResult.IsSuccessful is false on response
 * 	2. store operationResult inside model like this.operationResult
 *  3. store last successfull in terms of AJAX operation inside moadel like this.lastOperation
 *  4. emulate all ajax calls except 'GET' if Backbone.customDesign.emulateAjax is true
 */
Backbone.customDesign = {
	startEmulateAjax () {

		this.emulateAjax = true;

	},
	stopEmulateAjax () {

		this.emulateAjax = false;

	},
	isEmulateOn () {

		return this.emulateAjax;

	},
	emulateAjax: false,
	sync (method, model, options) {

		const lastMethod = method;
		const { wait } = options;
		const dfd = $.Deferred();
		const origSuccess = options.success;
		const origError = options.error;

		// clone model if coming from cart or wishlist and making a change
		if (
			(document.referrer.search('/cart/') > -1 || document.referrer.search('/wish-list/') > -1)
			&& qtee.customDesign.sceneLoaded
			&& !qtee.customDesign.sceneCloned
			&& !Backbone.customDesign.isEmulateOn()
		) {

			model.attributes.IsReadOnly = 1;

		}

		// replace original success/error handlers
		options.success = (r, textStatus, xhr) => {

			// if model was previously destroyed then silently call success
			if (this.lastOperation == 'delete') {

				dfd.resolve.apply(xhr, [ r, textStatus, xhr ]);
				origSuccess && origSuccess(r, textStatus, xhr);
				return;

			}

			if (
				r
				&& r.CustomizedProductSprites
				&& r.CustomizedProductSprites.CustomizedPattern
				&& r.CustomizedProductSprites.CustomizedPattern.CustomizedProductToken
			) {

				$(qtee.customDesign).trigger(
					'cloneSuccess',
					r.CustomizedProductSprites.CustomizedPattern.CustomizedProductToken
				);

			} else if (
				r
				&& r.CustomizedProductSprites
				&& r.CustomizedProductSprites.CustomizedText
				&& r.CustomizedProductSprites.CustomizedText.CustomizedProductToken
			) {

				$(qtee.customDesign).trigger(
					'cloneSuccess',
					r.CustomizedProductSprites.CustomizedText.CustomizedProductToken
				);

			} else if (
				r
				&& r.CustomizedProductSprites
				&& r.CustomizedProductSprites.CustomizedImage
				&& r.CustomizedProductSprites.CustomizedImage.CustomizedProductToken
			) {

				$(qtee.customDesign).trigger(
					'cloneSuccess',
					r.CustomizedProductSprites.CustomizedImage.CustomizedProductToken
				);

			} else if (lastMethod == 'delete' && r && r.CustomizedProductToken) {

				$(qtee.customDesign).trigger('cloneSuccess', r.CustomizedProductToken);

			}

			this.lastOperation = lastMethod;
			this.operationResult = r.OperationResult;

			if (r.OperationResult.IsSuccessful) {

				dfd.resolve.apply(xhr, [ r, textStatus, xhr ]);
				origSuccess && origSuccess(r, textStatus, xhr);

			} else {

				dfd.reject.apply(xhr, [ xhr, 'error', r.OperationResult.ErrorMessage ]);
				origError && origError(xhr, 'error', r.OperationResult.ErrorMessage);
				// destroy model if it was already created and added to collection by Backbone
				if (!wait && this.lastOperation == 'create') {

					this.destroy();

				}

			}

		};

		options.error = (xhr, msg, error) => {

			dfd.reject.apply(xhr, arguments);
			origError && origError(xhr, msg, error);

		};

		// Ajax emulation for all methods except 'read' since REST API call 'read' should not change anything on backend
		if (method !== 'read' && Backbone.customDesign.isEmulateOn()) {

			// generate fake successfull respond from server
			const response = {
				OperationResult: { IsSuccessful: true }
			};
			var type = qtee.customDesign.settings.names[model.type];

			if (type) {

				// it's a element's model request
				response.CustomizedProductSprites = {};
				response.CustomizedProductSprites[type.element] = model.attributes;

				if (method == 'create') {

					response.CustomizedProductSprites[type.element].Token = model.generateFakeId();

				}

			} else if (model.area) {

				// it's a customized product model request
				response.Product = model.attributes;
				response.Product.AreaInfo = model.area;

				var type;
				let map;
				for (type in qtee.customDesign.settings.names) {

					map = qtee.customDesign.settings.names[type];
					response.Product[map.elements] = [];
					for (let i = 0; i < model.elements[map.collection].models.length; i++) {

						response.Product[map.elements].push(model.elements[map.collection].models[i].attributes);

					}

				}

			} else {

				throw 'Unknown model';

			}

			// create fake xhr object
			const xhr = (options.xhr = $.Deferred());
			model.trigger('request', model, xhr, options);
			options.success && xhr.done(options.success);
			options.error && xhr.fail(options.error);
			options.complete && xhr.always(options.complete);

			if (model.changed.ShortSku) {

				const prodModel = new qtee.shared.ProdModel({ ShortSku: model.get('ShortSku') });
				prodModel.fetch().then((r) => {

					// area was changed
					response.Product.AreaInfo = r.AreaInfo;
					response.Product.AreaInfo.BackgroundImageUrl = model.area.BackgroundImageUrl.replace(
						model._previousAttributes.ShortSku.toLowerCase(),
						model.attributes.ShortSku.toLowerCase()
					);

					// update ImageUrl
					response.Product.ImageUrl =						qtee.customDesign.utils.modelImgUrlBuilder.getNewImageUrlByModelAndProdModel(model, prodModel);

					response.Product.IsSkuChanged = true;

					// rescale elements
					let type;
					let map;
					let scale;
					let wRatio;
					let hRatio;

					hRatio = r.AreaInfo.Height / model.area.Height;
					wRatio = r.AreaInfo.Width / model.area.Width;
					scale = Math.min(hRatio, wRatio);

					for (type in qtee.customDesign.settings.names) {

						map = qtee.customDesign.settings.names[type];
						for (let i = 0; i < response.Product[map.elements].length; i++) {

							response.Product[map.elements][i][
								response.Product[map.elements][i].FontSize ? 'FontSize' : 'Scale'
							] *= scale;
							response.Product[map.elements][i].OriginX *= wRatio;
							response.Product[map.elements][i].OriginY *= hRatio;

						}

					}

					xhr.resolve(response);

				}, xhr.reject);

			} else {

				// for fair emulation we should reslove it in separate JS Event Loop
				setTimeout(() => {

					xhr.resolve(response);

				}, 0);

			}

		} else {

			// HACK: force is new to be false when getting model after cloning
			if (method === 'read' && model && model.lastOperation === 'create') {

				this.isNew = function () {

					return false;

				};

			}
			Backbone.sync.call(this, method, model, options);

		}

		return dfd.promise();

	}
};

/** Preview */
qtee.customDesign.Preview = Backbone.Model.extend({
	urlRoot: '/api/customizedproducts/preview/',
	url: function url () {

		return this.urlRoot + this.get('Token');

	}
});

/** Available patterns */
qtee.customDesign.AvailablePatterns = Backbone.Model.extend({
	urlRoot: '/api/customizedproducts/patterns/customizablepatterns?pageSize=200',
	parse (r, opt) {

		const patterns = r.Result.Graphics;
		let backgrounds = r.Result.Backgrounds;

		this.operationResult = r.OperationResult;

		// clone backgrounds from patterns if null
		if (!backgrounds) {

			backgrounds = _.clone(patterns);

		}

		backgrounds.unshift({
			PatternId: null,
			PatternImageUrl: null
		});

		return r && r.OperationResult.IsSuccessful ? { patterns, backgrounds } : {};

	},
	sync: Backbone.customDesign.sync,
	getImageUrlById (id) {

		return _.findWhere(this.get('patterns'), { PatternId: id });

	}
});

/** Available basic colors (swatches) */
qtee.customDesign.AvailableColors = Backbone.Model.extend({
	urlRoot: '/api/color-customizer/product-color-palette/lampsplus/',
	parse (r, opt) {

		return { colors: r };

	}
});

/** Model of Elements */
qtee.customDesign.ElementModel = Backbone.Model.extend({
	idAttribute: 'Token',
	initialize (attrs, opts) {

		this.type = (opts.type || opts.collection.type).toLowerCase();
		this.delayedSave = delayedCall(this, this.save, qtee.customDesign.settings.text.milliseconds);

	},
	generateFakeId () {

		return `FakeId:${Date.now()}${Math.random()}`;

	},
	clearId () {

		this.id = this.attributes[this.idAttribute] = undefined;

	},
	isFakeId () {

		return (this.id && this.id.split(':')[0]) === 'FakeId';

	},
	_concurencyControl (obj) {

		// don't change model if VersionNumber is less than current VersionNumber
		return obj.VersionNumber < this.get('VersionNumber') ? {} : obj;

	},
	parse (r, opt) {

		if (r.CustomizedProductSprites.CustomizedText) {

			return this._concurencyControl(r.CustomizedProductSprites.CustomizedText);

		}
		if (r.CustomizedProductSprites.CustomizedImage) {

			return this._concurencyControl(r.CustomizedProductSprites.CustomizedImage);

		}
		if (r.CustomizedProductSprites.CustomizedPattern) {

			return this._concurencyControl(r.CustomizedProductSprites.CustomizedPattern);

		}

		throw 'Unknown type';

	},
	sync: Backbone.customDesign.sync,
	destroy (opts) {

		this.delayedSave.cancel();
		let result = Backbone.Model.prototype.destroy.call(this, opts);

		if (result === false) {

			result = Promise.resolve();

		}

		return result.then(() => $(qtee.customDesign).trigger('customDesignChangeMade'));

	},
	save (attrs, opts) {

		// purge delayed call if one exist
		this.delayedSave.cancel();

		// silently ignore save if model was previously deleted
		if (this.lastOperation === 'delete') {

			return;

		}

		// HACK: we need to use direct access to attributes instead of .set() method otherwise this.changed has only 'VersionNumber' property
		this.attributes.VersionNumber = this.get('VersionNumber') + 1;

		const xhr = Backbone.Model.prototype.save.call(this, attrs, opts);

		this._savedPreviousAttributes = _.clone(this._previousAttributes);
		delete this._savedPreviousAttributes.VersionNumber;
		delete this._savedPreviousAttributes.Token;
		delete this._savedPreviousAttributes.TimeStamp;

		return xhr.then(() => {

			$(qtee.customDesign).trigger('customDesignChangeMade');

		});

	},
	clone () {

		return new this.constructor(this.attributes, { type: this.type });

	},
	isSame (other) {

		let attr;
		let attr2;

		attr = _.clone(this.attributes);
		delete attr.VersionNumber;
		attr2 = _.clone(other.attributes);
		delete attr2.VersionNumber;

		return _.isEqual(attr, attr2);

	}
});

/** Collection of Elements */
qtee.customDesign.ElementsCollection = Backbone.Collection.extend({
	model: qtee.customDesign.ElementModel,
	initialize (models, opts) {

		this.prodToken = opts.prodToken;
		this.type = opts.type;

	},
	url () {

		return `/api/customizedproducts/${this.prodToken}/${this.type}`;

	},
	clone (deep) {

		if (deep) {

			return new this.constructor(
				_.map(this.models, (m) => m.clone()),
				{
					model: this.model,
					comparator: this.comparator,
					type: this.type,
					prodToken: this.prodToken
				}
			);

		}

		return Backbone.Collection.prototype.clone();

	},
	isSame (other) {

		if (this.length !== other.length) {

			return false;

		}

		for (let i = 0; i < this.models.length; i++) {

			if (!this.models[i].isSame(other.models[i])) {

				return false;

			}

		}

		return true;

	}
});

/** Scene Model */
qtee.customDesign.ProductModel = Backbone.Model.extend({
	idAttribute: 'Token',
	urlRoot () {

		return '/api/customizedproducts/';

	},
	sync: Backbone.customDesign.sync,
	initialize (opts) {

		this.elements = {};

	},
	parse (r, opt) {

		let type;
		let map;
		for (type in qtee.customDesign.settings.names) {

			map = qtee.customDesign.settings.names[type];
			this.elements[map.collection] = new qtee.customDesign.ElementsCollection(r.Product[map.elements], {
				prodToken: r.Product.Token,
				type
			});
			// remove it from model since we saved it in collection
			delete r.Product[map.elements];

		}

		if (getQueryStringValue('sku')) {

			r.Product.ShortSku = getQueryStringValue('sku');

		}

		// we don't need to send 'AreaInfo' back to server
		this.area = r.Product.AreaInfo;
		delete r.Product.AreaInfo;

		// sice we don't use this so we don't need to keep it
		delete r.Product.ZOrderInfo;

		return r.Product;

	},
	cloneByToken (attrs, opts) {

		const { isNew } = this;
		this.attributes[this.idAttribute] = opts.cloneByToken;
		this.isNew = function () {

			return true;

		};

		const xhr = Backbone.Model.prototype.save.call(this, attrs, opts);

		// restore isNew default function after save call
		this.isNew = isNew;

		return xhr;

	},
	cloneBySprites (attrs, opts) {

		let els;

		_.each(qtee.customDesign.settings.names, (type) => {

			const els = this.elements[type.collection].toJSON();
			els.forEach((el) => {

				delete el.Token;
				delete el.TimeStamp;
				delete el.VersionNumber;
				delete el.DateUpdated;

			});

			this.set(type.elements, els);

		});

		delete this.attributes.Token;
		delete this.attributes.ImageUrl;
		delete this.attributes.TimeStamp;
		delete this.attributes.VersionNumber;
		delete this.attributes.DateUpdated;

		return Backbone.Model.prototype.save.call(this, attrs, opts);

	},
	/** Pass opts.cloneByToken to force model to use POST and clone by provided token */
	save (attrs, opts) {

		let xhr;
		// HACK: we need to use direct access to attributes instead of .set() method otherwise this.changed has only 'VersionNumber' property
		this.attributes.VersionNumber = this.get('VersionNumber') + 1;

		// clone the whole model by its token
		if (opts && opts.cloneByToken) {

			xhr = this.cloneByToken(attrs, opts);

		} else if (opts && opts.cloneBySprites) {

			// clone the whole model by their sprites
			xhr = this.cloneBySprites(attrs, opts);

		} else {

			// default save
			xhr = Backbone.Model.prototype.save.call(this, attrs, opts);

		}

		return xhr.then(() => {

			$(qtee.customDesign).trigger('customDesignChangeMade');

		});

	},
	/**
	 * Clone model on front-end. Return new Backbone-model
	 * @return {ProductModel}
	 */
	clone () {

		let r;
		let collection;
		const elements = {};
		// foreach element type
		for (const type in qtee.customDesign.settings.names) {

			collection = qtee.customDesign.settings.names[type].collection;
			elements[collection] = this.elements[collection].clone(true);

		}
		r = new this.constructor(this.attributes);
		r.elements = elements;
		r.area = _.clone(this.area);
		return r;

	},
	/**
	 * Compare two models
	 * @param  {ProductModel}  other
	 * @return {Boolean} return true if this model and other model have same ShortSku and same sprites
	 */
	isSame (other) {

		return (
			this.get('ShortSku') === other.get('ShortSku')
			&& this.elements.text.isSame(other.elements.text)
			&& this.elements.image.isSame(other.elements.image)
			&& this.elements.pattern.isSame(other.elements.pattern)
		);

	},
	isPillow () {

		return this.get('ShortSku') === qtee.customDesign.settings.defaultSku;

	},
	isEmpty () {

		return Object.keys(this.elements).length === 0;

	}
});

qtee.customDesign.CustomUploadProducts = Backbone.Model.extend({
	url: '/api/customizedproducts/customuploadproducts',
	parse (r) {

		return {
			categories: _.map(r, (el, key) => ({ name: key, data: el }))
		};

	}
});
